import React from 'react';
import { Carousel } from 'react-bootstrap';

const ClientSay = () => (
  <section id="clients" className="bg-light py-5">
    <div className="container">
      <h2 className="text-center mb-4">What Our Clients Say</h2>
      <Carousel indicators={false} interval={4000} fade>
        <Carousel.Item>
          <div className="text-center px-4">
            <p className="lead">“The powder coating finish was flawless. Highly recommended!”</p>
            <h5 className="mt-3">— Laxmi Engineering</h5>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="text-center px-4">
            <p className="lead">“Excellent service and great attention to detail.”</p>
            <h5 className="mt-3">— Sona Electricals</h5>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <div className="text-center px-4">
            <p className="lead">“Timely delivery and top-notch quality. Will use again.”</p>
            <h5 className="mt-3">— Durand Controal</h5>
          </div>
        </Carousel.Item>
         <Carousel.Item>
          <div className="text-center px-4">
            <p className="lead">“The powder coating finish was flawless. Highly recommended!”</p>
            <h5 className="mt-3">— Electical Control Center</h5>
          </div>
        </Carousel.Item>
         <Carousel.Item>
          <div className="text-center px-4">
            <p className="lead">“The powder coating finish was flawless. Highly recommended!”</p>
            <h5 className="mt-3">— Etechno SwitchGear</h5>
          </div>
        </Carousel.Item>
      </Carousel>
    </div>
  </section>
);

export default ClientSay;
